import { Checkout } from "arv-extends/constants";

Checkout.CHECKOUTPAGE.CHEKOUT_EMPTY_MSG =
  "Oh, your cart seems empty. Start Shopping.";
Checkout.CHECKOUT_BUTTON_TEXTS.EDIT_BAG = "EDIT CART";
Checkout.CHECKOUT_MESSAGES.COUPON_MESSAGE.REMOVE =
  "Coupon has been removed from your cart";
Checkout.CHECKOUT_MESSAGES.COUPON_MESSAGE.INVALID =
  "Oh no! This coupon isn't valid for your cart. Please check terms and conditions of the coupon";
Checkout.CHECKOUT_EMPTY_STATE.IMAGE_ALT_TEXT = "Empty cart here";
Checkout.CHECKOUT_MESSAGES.PAYMENT_FAILURE.LOYALTY_ERROR="";
export default Checkout;
